import { EditText } from '../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import globalSettingsStores from '../../../../stores/settings-stores';
import { SettingsServicePaymentType } from '../../../../api/types/settings/payments/settings-service-payment-type';
import { addNewServiceOperation } from '../operations/add-new-service-operation';

export interface AddPaymentServiceDialogModel {
  closeDialog: () => void;
}

export const AddPaymentServiceDialog: React.FC<
  AddPaymentServiceDialogModel
> = ({ closeDialog }) => {
  const [serviceName, setServiceName] = useState('');
  const [price, setPrice] = useState<number | null>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedPaymentServiceType, setSelectedPaymentServiceType] = useState<
    SettingsServicePaymentType[] | null
  >(null);

  const handleOnSubmit = async () => {
    await addNewServiceOperation(
      serviceName,
      price,
      selectedPaymentServiceType?.[0] ?? null,
      setLoading,
      closeDialog,
    );
  };

  return (
    <div>
      <EditText
        title={'שם השרות'}
        onChange={setServiceName}
        height={'43.5px'}
      />
      <div
        style={{
          flex: '1', // Flex-grow, flex-shrink, and base size of 250px
          minWidth: '250px', // Ensure a minimum width of 250px
          marginTop: '16px',
          marginBottom: '16px', // Optional bottom margin for row spacing
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ fontSize: '14px', color: '#4b5563' }}>סכום</div>
        <InputNumber
          style={{ direction: 'ltr', width: '100%', marginTop: '8px' }}
          inputStyle={{ direction: 'rtl' }}
          inputId="currency-us"
          value={price}
          onValueChange={(e) => setPrice(e.value)}
          mode="currency"
          currency="NIS"
          showButtons
          locale="en-US"
        />
      </div>

      <div
        style={{
          flex: '1', // Flex-grow, flex-shrink, and base size of 250px
          minWidth: '250px', // Ensure a minimum width of 250px
          marginTop: '16px',
          marginBottom: '16px', // Optional bottom margin for row spacing
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ fontSize: '14px', color: '#4b5563' }}>בחירת סוג שרות</div>
        <MultiSelect
          style={{ width: '100%', marginTop: '8px' }}
          value={selectedPaymentServiceType}
          onChange={(e) => setSelectedPaymentServiceType(e.value)}
          options={globalSettingsStores.servicePaymentTypes}
          optionLabel="paymentServiceTypeName"
          filter
          placeholder="לחץ לבחירת סוג התשלום"
          maxSelectedLabels={1}
          max={1}
          selectionLimit={1}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'left' }}>
        <Button label="אישור" onClick={handleOnSubmit} />
      </div>
    </div>
  );
};
